import store from '@/store';

export default (to, from, next) => {
    const is_customer_group_allowed = store.getters.is_app_environment_enabled_customer_groups_menu_item;

    return {
        allow: is_customer_group_allowed,
        redirect: { name: 'not-found' },
    }
};
